import { removeTrapFocus, trapFocus } from '../storefront/globals';

class HeaderSearch extends HTMLElement {
  constructor() {
    super();

    this.searchModal = this.querySelector('.js-header-search-modal');
    this.setHeaderSearchIconAccessibility();
  }

  setHeaderSearchIconAccessibility() {
    const headerSearchIcons = document.querySelectorAll(
      '.js-header-search-button',
    );

    headerSearchIcons.forEach((el) => {
      el.setAttribute('role', 'button');
      el.setAttribute('aria-haspopup', 'dialog');

      el.addEventListener('click', (event) => {
        event.preventDefault();

        if (this.hasAttribute('open')) {
          this.close();
        } else {
          this.open(el);
        }
      });

      el.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();

          if (this.hasAttribute('open')) {
            this.close();
          } else {
            this.open(el);
          }
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.setAttribute('open', '');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('input[name="q"]');
        trapFocus(this.searchModal, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('tw-overflow-hidden');
  }

  updateFocusTrap() {
    setTimeout(() => {
      trapFocus(this.searchModal, null);
    });
  }

  close() {
    this.removeAttribute('open');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('tw-overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('header-search', HeaderSearch);
